module.exports = __webpack_public_path__ + "assets/img/3.1fc04be6.png";